module.exports = __webpack_public_path__ + "static/img/2.5cfe563.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/eng/2.png
// module id = R8qn
// module chunks = 0